var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7018 4.70175L7.70175 9.70175C7.52632 9.89474 7.2807 10 7 10C6.45614 10 6 9.54386 6 9C6 8.7193 6.10526 8.47368 6.29825 8.29825L11.2982 3.29825C11.4737 3.10526 11.7193 3 12 3C12.5439 3 13 3.45614 13 4C13 4.2807 12.8947 4.52632 12.7018 4.70175ZM16.2982 9.70175L11.2982 4.70175C11.1053 4.52632 11 4.2807 11 4C11 3.45614 11.4561 3 12 3C12.2807 3 12.5263 3.10526 12.7018 3.29825L17.7018 8.29825C17.8947 8.47368 18 8.7193 18 9C18 9.54386 17.5439 10 17 10C16.7193 10 16.4737 9.89474 16.2982 9.70175Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2982 19.2982L16.2982 14.2982C16.4737 14.1053 16.7193 14 17 14C17.5439 14 18 14.4561 18 15C18 15.2807 17.8947 15.5263 17.7018 15.7018L12.7018 20.7018C12.5263 20.8947 12.2807 21 12 21C11.4561 21 11 20.5439 11 20C11 19.7193 11.1053 19.4737 11.2982 19.2982ZM7.70175 14.2982L12.7018 19.2982C12.8947 19.4737 13 19.7193 13 20C13 20.5439 12.5439 21 12 21C11.7193 21 11.4737 20.8947 11.2982 20.7018L6.29825 15.7018C6.10526 15.5263 6 15.2807 6 15C6 14.4561 6.45614 14 7 14C7.2807 14 7.52632 14.1053 7.70175 14.2982Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorder);
export default __webpack_public_path__ + "static/media/reorder.3ef4cce8.svg";
export { ForwardRef as ReactComponent };